import { render, staticRenderFns } from "./EditAfiliado.vue?vue&type=template&id=0d477827&scoped=true&"
import script from "./EditAfiliado.vue?vue&type=script&lang=js&"
export * from "./EditAfiliado.vue?vue&type=script&lang=js&"
import style0 from "./EditAfiliado.vue?vue&type=style&index=0&id=0d477827&prod&lang=scss&scoped=true&"
import style1 from "./EditAfiliado.vue?vue&type=style&index=1&id=0d477827&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d477827",
  null
  
)

export default component.exports